import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EnterprisesService {
    private baseUrl = 'https://api.clico.com.mx/api/helpers';

    constructor(private http: HttpClient) {}

    /** Obtener lista de estados */
    getEstados(): Observable<any[]> {
        return this.http.get<any[]>(`${this.baseUrl}/getStates`);
    }

    /** Obtener municipios según el estado */
    getMunicipios(estado: string): Observable<any[]> {
        return this.http.post<any[]>(`${this.baseUrl}/getMunicipalities`, {
            estado,
        });
    }

    /** Enviar formulario  */
    enviarFormulario(data: any): Observable<any> {
        return this.http.post(
            'https://api.clico.com.mx/api/form/enterprise',
            data,
        );
    }
}
